import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["popover", "trigger"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    this.removeEventListeners()
  }

  toggle(event) {
    event.preventDefault()
    this.openValue = !this.openValue
    this.updateState()
  }

  close() {
    this.openValue = false
    this.updateState()
  }

  updateState() {
    if (this.openValue) {
      this.open()
    } else {
      this.closePopover()
    }
  }

  open() {
    if (this.hasPopoverTarget) {
      this.popoverTarget.hidden = false
    }
    
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "true")
    }

    this.addEventListeners()
  }

  closePopover() {
    if (this.hasPopoverTarget) {
      this.popoverTarget.hidden = true
    }
    
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "false")
    }

    this.removeEventListeners()
  }

  addEventListeners() {
    document.addEventListener("click", this.closeOnClickOutside)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  removeEventListeners() {
    document.removeEventListener("click", this.closeOnClickOutside)
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
      if (this.hasTriggerTarget) {
        this.triggerTarget.focus()
      }
    }
  }

  openValueChanged() {
    this.updateState()
  }
}
